import { mountAtlasForecastingApp } from "./atlas_forecasting_app/mount"

mountAtlasForecastingApp()
